<template>
  <div v-if="totalPage >= 2" class="flex items-center justify-center">
    <div class="flex flex-wrap justify-center">
      <TheNuxtLink
        v-for="{ pageNumber, pageLink } in pageItems"
        :key="pageNumber"
        :to="pageLink"
        :title="`${pageNumber}`"
        :class="provideClassName(pageNumber)"
        class="mr-1 h-8 w-8 text-center font-bold text-blue-400 underline hover:text-blue-500"
        @click="handleClick(pageNumber)"
      >
        {{ pageNumber }}
      </TheNuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router';

  interface IPageItem {
    pageNumber: number;
    pageLink: RouteLocationRaw;
  }

  interface IProps {
    pageItems: IPageItem[];
    pageIndex: number;
  }

  const props = defineProps<IProps>();

  const emit = defineEmits<{ (e: 'click', value: number): void }>();

  const totalPage = computed((): number => {
    return props.pageItems.length;
  });

  const provideClassName = (pageNumber: number): string => {
    if (props.pageIndex === pageNumber) {
      return 'bg-blue-400/10 border border-solid border-blue-400 rounded';
    }
    return '';
  };

  const handleClick = (pageNumber: number): void => {
    if (props.pageIndex === pageNumber) {
      return;
    }
    emit('click', pageNumber);
  };

  export type { IPageItem };
</script>
